<!-- 质量管理 圆环图 -->
<template>
  <div style="height:100%;width:100%">
    <div class="line-wrapper" :style="{height:height,width:width}" style="marginTop:10px;position: relative">
      <div class="noDateShow" v-if="noDateShow">暂无数据</div>
      <div class="line-content" :id="id"></div>
      <!-- <div id="pic"></div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: ["height","width", "chartOption","typeShow"],
  data() {
    return {
      id: this.uuid(),
      screenshots:'',
      noDateShow: false
    };
  },
  computed: {},
  created() {},
  watch: {
    // chartOption: function (newV) {
    //   console.log(newV)
    //   if(newV.series.length==0){
    //     this.noDateShow=true
    //   }else{
    //     this.noDateShow=false
    //   }
    //   this.setChart();
    // },
    chartOption: {
      handler(newV) {
        console.log('变化',this.typeShow)
        if(newV.series.length==0){
          this.noDateShow=true
        }else{
          this.noDateShow=false
        }
        this.setChart();
      },
      deep: true,
    },
  },
  mounted() {
    const echarts = require("echarts");
    this.$nextTick(()=> {
      console.log('获取',this.typeShow)
      // this.myChart = '' 
      this.myChart = echarts.init(document.getElementById(this.id));
      console.log(this.id,this.typeShow)
      console.log(this.myChart,this.typeShow)
      this.setChart();
      setTimeout(()=>{
        this.screenshots = new Image();
        this.screenshots.src = this.myChart.getConnectedDataURL({
            pixelRatio: 1,
        });
        this.$emit('childLine',this.screenshots)
      },1000) 
    }); 
  },
  methods: {
    setChart() {
      const option = Object.assign(
        {
          color: ["#4facf9", "#e86b59"],
          dataZoom: [
            {
              type: "slider",
              show: true,
              xAxisIndex: [0],
              start: 100-(this.chartOption || {}).dataZoomEnd || 30,
              // start:0,
              end: 100, //dataZoomEnd展示百分比
              height: 8,
              handleSize: 0,
              showDetail: false,
              showDataShadow: false,
              bottom: 0,
              backgroundColor: "#e4e3e8",

              handleStyle: {
                borderWidth: 0,
                color: "#c0c0c8",
              },
            },
          ],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
          },
          grid: {
            bottom: 40,
            top: 30,
          },
        },
        this.chartOption || {
          legend: {
            data: ["蒸发量", "降水量", "平均温度"],
          },
          xAxis: [
            {
              type: "category",
              data: [
                "1月",
                "2月",
                "3月",
                "4月",
                "5月",
                "6月",
                "7月",
                "8月",
                "9月",
                "10月",
                "11月",
                "12月",
              ],
              axisPointer: {
                type: "shadow",
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              name: "水量",
              // min: 0,
              // max: 250,
              // interval: 50,
              axisLabel: {
                formatter: "{value} ml",
              },
            },
            {
              type: "value",
              name: "温度",
              min: 0,
              max: 25,
              interval: 5,
              axisLabel: {
                formatter: "{value} °C",
              },
            },
          ],
          series: [
            {
              name: "蒸发量",
              type: "bar",
              barMaxWidth: 15,
              data: [
                2.0,
                4.9,
                7.0,
                23.2,
                25.6,
                76.7,
                135.6,
                162.2,
                32.6,
                20.0,
                6.4,
                3.3,
              ],
            },
            {
              name: "平均温度",
              type: "line",
              yAxisIndex: 1,
              data: [
                2.0,
                2.2,
                3.3,
                4.5,
                6.3,
                10.2,
                20.3,
                23.4,
                23.0,
                16.5,
                12.0,
                6.2,
              ],
            },
          ],
        }
      );
      //console.log(option);
      this.myChart.clear()
      console.log('更新',this.typeShow)
      this.myChart.setOption(option);
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped="">
.noDateShow{
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba($color: #ffffff, $alpha: 0.7);
  z-index: 100;
  text-align: center;
  line-height: 300px;
}
.line-wrapper{
  height: 100%;
  width: 100%;
}
.line-content {
  height: 100%;
  width: 1535px;
}
</style>